import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface RejectVDRFileRemovalRequest {
    engagementId: number;
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export const RejectVDRFileRemoval = createAsyncThunk(
    'dataRoom/rejectFileRemoval',
    async (
        { engagementId, fileId, fileSourceType }: RejectVDRFileRemovalRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}/reject-removal?fileSourceType=${fileSourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not reject file removal at the moment.',
                    'error'
                );
                throw new Error('Failed to reject file removal');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while rejecting file removal.',
                'error'
            );
            throw error;
        }
    }
);

